module.exports = __webpack_public_path__ + "media/tr_tr_s1_Aylin.a355ae77.oga";